import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { FEATURE_TOGGLES } from 'lumen/utils/constants/feature-toggle-constants';

// Flag-gated entry point for the seasonal room-offset hierarchy on the PMS integration
// page. The modal opened here lands in INDU-1674.
export default class SettingsPmsIntegrationSeasonalRoomHierarchySection extends Component {
  @service declare access: Services['access'];
  @service declare featureToggle: Services['feature-toggle'];

  @tracked isModalOpen = false;

  get isFeatureEnabled(): boolean {
    return this.featureToggle.hasFeatureToggle(
      FEATURE_TOGGLES.PRICING_MANAGER_SEASONAL_ROOM_HIERARCHY,
    );
  }

  get isReadOnly(): boolean {
    return this.access.isPricingAssistantPmsSettingsActionOrInputDisabled;
  }

  @action
  openModal(): void {
    this.isModalOpen = true;
  }

  <template>
    {{#if this.isFeatureEnabled}}
      <div class="divider-line"></div>

      <div
        class="flex flex-row items-center justify-between"
        data-test-id="seasonal-room-hierarchy-section"
      >
        <p class="text-200--bold">{{t
            "pricing_assistant.recommendations.price_range.subtitle.seasonal_strategies"
          }}</p>

        <PrismButton
          @buttonType="secondary"
          @label={{if this.isReadOnly (t "general.view") (t "general.edit")}}
          @onClick={{this.openModal}}
        />
      </div>
    {{/if}}
  </template>
}
